export default "__VITE_ASSET__DZM0m0X___"